const htmlEl = document.querySelector('html')

htmlEl.classList.remove('no-js')
htmlEl.classList.add('js')